<template lang="pug">
  #app.text-dark
    router-view
</template>

<script>

import { mapActions, mapMutations, mapState } from "vuex";

import loadingMessage from "./utils/loadingMessage";

export default {
  name: "App",
  data() {
    return {};
  },
  async created() {
    // get configuration
    this.handleShowModal(loadingMessage({
      title: "Cargando variables de entorno",
      state: "loading",
    }));
    try {
      await this.fetchEnvironment();
      if(this.closeModal) this.closeModal();
    } catch (error) {
      console.error("[error: Falla en el servicio]:", error);
      this.handleShowModal(loadingMessage({
        title: "Lo sentimos ocurrió un error al traer las variables de entorno",
        state: "danger",
      }));
    }
    if (!("loading" in HTMLImageElement.prototype)) {
      let script = document.createElement("script");
      script.async = true;
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.2.0/lazysizes.min.js";
      document.body.appendChild(script);
    }
  },
  computed: {
    ...mapState({
      closeModal: (state) => state.root.closeModal
    })
  },
  methods: {
    ...mapActions(["fetchEnvironment"]),
    ...mapMutations("root", [
      "setState",
    ]),
    ...mapActions("root", [
      "handleShowModal"
    ]),
  },
}
</script>

<style>
@font-face {
  font-family: "DM_sans";
  src: url(./assets/fonts/DM_Sans/DMSans-Regular.ttf) format("ttf"),
    url(./assets/fonts/DM_Sans/DMSans-Bold.ttf) format("ttf"),
    url(./assets/fonts/DM_Sans/DMSans-BoldItalic.ttf) format("ttf"),
    url(./assets/fonts/DM_Sans/DMSans-Medium.ttf) format("ttf"),
    url(./assets/fonts/DM_Sans/DMSans-MediumItalic.ttf) format("ttf");
  font-weight: normal;
  font-style: normal;
}

* {
  font-family: "DM Sans", sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  overflow-x: hidden;
}

body {
  background-color: #FBFBFB;
}

html,
body {
  overscroll-behavior-y: contain;
}

.FooterHide {
  opacity: 0;
  transition: 1s all;
}

.content {
  /* height: calc(100vh - 242.433px) !important; */
  overflow: auto;
  padding-bottom: 10px;
}

.contentImportant {
  /* height: calc(100vh - 242.433px) !important; */
  overflow: auto;
  padding-bottom: 10px;
}

.ArrowScoped {
  width: 2.5rem;
  height: 2.5rem;
  min-width: 2.5rem;
  min-height: 2.5rem;
  background-color: #a5c8f382;
}

.maximagLoad {
  max-width: 30px;
}

.Arrow {
  background-color: #88a8d082;
  outline: none;
  top: 30px;
  left: 20px;
}

.generalLabel {
  border-bottom: 2px solid rgb(219, 217, 217);
}

.vs__dropdown-toggle {
  border: none;
}

.vs__open-indicator, .vs__clear {
  fill: #1F4695;
  color: #1F4695;
}

.content_sm {
  /* height: calc(100vh - 308.433px) !important;
  overflow: auto; */
  padding-bottom: 10px;
}

.Footer {
  bottom: -9px;
  z-index: 999999999;
  /* opacity: 0.7; */
  background: #FBFBFB;
}

.Footer button {
  padding: 9px;
}

.selected-enter-active, .selected-leave-active {
  transition: 0.5s;
  animation: smallContent 0.5s forwards ease-in-out;
}

.selected-enter, .selected-leave-to /* .selected-leave-active below version 2.1.8 */ {
  animation: smallContent 0.5s backwards ease-in-out alternate-reverse;
}

.cropper-point {
  height: 10px;
  width: 10px;
}

.list-enter-active, .list-leave-active {
  transition: all 1s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@keyframes fadeInY {
  0% {
    transform: translateY(-160px);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes fade {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    transform: scale(0.35);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes smallContent {
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }
  90% {
    opacity: 0.08;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

@keyframes onlyFade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.6;
  }
}

@keyframes onlyFadeImg {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeTop {
  0% {
    transform: translateY(10000px);
  }
  100% {
    transform: translateY(0);
  }
}

/* @media screen and (max-height: 550px) {
  .content {
    height: calc(100vh - 280px);
  }
} */
</style>
